import Link from 'next/link'
import { useRouter } from 'next/router'

import classNames from 'classnames'

import type { PortableTextComponentProps } from '~/components/atoms/BlockContent/BlockContent'
import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import Container from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import Lozenge from '~/components/atoms/Lozenge/Lozenge'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import LozengeList from '~/components/blocks/LozengeList/LozengeList'
import { ComponentTheme } from '~/components/themes'

import styles from './PressHeader.module.css'

export interface PressHeaderProps {
  name: string
  summary?: PortableTextComponentProps['blocks'] | string
  subMenuItems?: { name: string; slug: string }[]
  includeAsSeenIn?: boolean
  testID?: string
  isPressCategory?: boolean
  theme?: ComponentTheme
}

export default function PressHeader({
  name,
  summary,
  subMenuItems,
  theme = ComponentTheme.primary,
  isPressCategory = false,
  testID,
}: PressHeaderProps) {
  const router = useRouter()

  return (
    <div className={styles.base} data-testid={testID}>
      <Fixture verticalPadding theme={theme}>
        <Container>
          <Text
            size={
              isPressCategory
                ? TextSizes.primaryTitleXLrg
                : TextSizes.magPrimaryTitleXLrg
            }
            Tag="h1"
            className={classNames(
              styles.title,
              summary && styles.marginBottom,
              isPressCategory && styles.pressCategoryTitle
            )}
            uppercase
          >
            {name}
          </Text>
          {summary && (
            <div className={styles.mw}>
              {summary &&
                (typeof summary === 'string' ? (
                  <Text size={TextSizes.bodyLrg} Tag="p">
                    {summary} banana
                  </Text>
                ) : (
                  <BlockContent value={summary} size={TextSizes.bodyLrg} />
                ))}
            </div>
          )}
          {subMenuItems && subMenuItems.length > 0 && (
            <div className={styles.subMenuContainer}>
              <LozengeList className={styles.subMenu}>
                {subMenuItems &&
                  subMenuItems.map((item, index) =>
                    router?.query?.slug === item.slug ? (
                      <Lozenge
                        count=""
                        key={`category-associated-item-${index}`}
                        title={item.name}
                        isActive={router?.query?.slug === item.slug}
                      />
                    ) : (
                      <Link
                        href={
                          router?.query?.slug === item.slug
                            ? '#'
                            : `/press/${item.slug}`
                        }
                        key={`category-associated-item-${index}`}
                      >
                        <Lozenge
                          count=""
                          title={item.name}
                          isActive={router?.query?.slug === item.slug}
                        />
                      </Link>
                    )
                  )}
              </LozengeList>
            </div>
          )}
        </Container>
      </Fixture>
    </div>
  )
}
